import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import ReactMarkdown from 'react-markdown';

import Divider from './Divider';
import Characteristic from '../../core/components/product/Characteristic';

const Container = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 0px;
  background-color: #fff;
`;

const Title = styled.h2`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 24px;
  line-height: 1.33;
  margin-bottom: 32px;
  color: #4a4a4a;
`;

const Text = styled(ReactMarkdown)`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #4a4a4a;
`;

const Bold = styled(Text)`
  font-weight: bold;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 450px;

  @media(max-width: 999px) {
    justify-content: space-between;
    padding: 0px 24px;
  }
`;

const Image = styled.img`
  width: 430px;
  margin-left: 124px;

  @media(max-width: 999px) {
    margin: 0 auto;
    width: 300px;
  }
`;

const Space = styled.div`
  ${({ size }) => `height: ${size}px`}
  ${({ size }) => `width: ${size}px`}
`;

const characteristics = [
  { checkmark: true, text: 'Anúncio volta ao topo **5 vezes**' },
  { checkmark: true, text: '7 dias com o selo **Destaque**', visualHighlight: true },
  { checkmark: true, text: '7 dias na Galeria' },
];

const GoldHighlightBox = ({ goldExplained }) => (
  <Container>
    {/* Desktop */}
    <MediaQuery minDeviceWidth={1000}>
      <Content>
        <Divider />
        <Title>O que é o Destaque Ouro?</Title>
        <Text>{goldExplained}</Text>
        <Space size={24} />
        <Bold>Características do Destaque Ouro:</Bold>
        {characteristics.map(characteristic => <Characteristic key={characteristic.text} characteristic={characteristic} />)}
      </Content>
      <Image src={`${process.env.PUBLIC_URL}/images/gold-highlight.png`} alt="Destaque Ouro" />

    </MediaQuery>
    {/* Mobile */}
    <MediaQuery maxDeviceWidth={999} >
      <Content>
        <Image src={`${process.env.PUBLIC_URL}/images/gold-highlight.png`} alt="Destaque Ouro" />
        <Divider />
        <Title>O que é o Destaque Ouro?</Title>
        <Text>{goldExplained}</Text>
        <Space size={24} />
        <Bold>Características do Destaque Ouro:</Bold>
        {characteristics.map(characteristic => <Characteristic key={characteristic.text} characteristic={characteristic} />)}
      </Content>
    </MediaQuery>
  </Container>
);

GoldHighlightBox.propTypes = {
  goldExplained: string.isRequired,
};

export default GoldHighlightBox;
